import React from 'react';

export interface AutocountAreaSelectionOverlayProps {
  pendingAutocountComponent: { name?: string } | null;
  queuedComponents: unknown[];
  onCancel: () => void;
}

export const AutocountAreaSelectionOverlay: React.FC<AutocountAreaSelectionOverlayProps> = ({
  pendingAutocountComponent,
  queuedComponents,
  onCancel,
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'rgba(59, 130, 246, 0.95)',
      color: 'white',
      padding: '16px 24px',
      borderRadius: '12px',
      fontSize: '15px',
      fontWeight: 500,
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
      zIndex: 100000,
      maxWidth: '500px',
      textAlign: 'center'
    }}>
      <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: 600 }}>
        {pendingAutocountComponent?.name
          ? `Select Reference Area for ${pendingAutocountComponent.name}`
          : 'Select Reference Area for Next Component'
        }
      </div>
      <div style={{ fontSize: '13px', opacity: 0.95 }}>
        Drag to select an area containing one example of the symbol
        {queuedComponents.length > 0 && (
          <span style={{ display: 'block', marginTop: '4px', fontWeight: 600 }}>
            {queuedComponents.length} component{queuedComponents.length > 1 ? 's' : ''} queued
          </span>
        )}
      </div>
      <button
        onClick={onCancel}
        style={{
          marginTop: '12px',
          padding: '6px 16px',
          background: 'rgba(255, 255, 255, 0.2)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '6px',
          color: 'white',
          fontSize: '13px',
          cursor: 'pointer',
          fontWeight: 500
        }}
      >
        Cancel
      </button>
    </div>
  );
};
